// =============================================================================
// ERROR LOGS — observability with detail. The app used to swallow failures into
// inline state strings; this captures them (client + server) so they can be
// seen and debugged. Single-user, additive-only.
// =============================================================================

import { index, jsonb, pgTable, text, varchar } from 'drizzle-orm/pg-core';
import { id, timestamps } from './_shared';

export const errorLogs = pgTable(
  'error_logs',
  {
    id: id(),
    userId: text('user_id'), // nullable: a pre-auth client error still logs
    source: varchar('source', { length: 8 }).notNull(), // 'client' | 'server'
    severity: varchar('severity', { length: 8 }).notNull().default('error'), // 'error'|'warn'|'fatal'
    message: text('message').notNull(),
    stack: text('stack'),
    context: jsonb('context').$type<{
      page?: string;
      action?: string;
      status?: number;
      [k: string]: unknown;
    }>(),
    ...timestamps,
  },
  (t) => ({ createdIdx: index('error_logs_created_idx').on(t.createdAt) }),
);
